import React, { createContext, useContext, useState } from 'react';

const OperatorContext = createContext(null);

/**
 * OperatorContext — provides operator-mode state to the form wizard.
 * Wraps the wizard when running under /admin/:secret/operator so that:
 *   - ReviewStep can show consent checkbox + optional consent ref input
 *   - Submission requests include X-Operator-Mode / X-Operator-Consent-Ref headers
 *   - A banner is rendered at the top of every step
 */
export const OperatorProvider = ({ children }) => {
  const [consentRef, setConsentRef] = useState('');
  const [consentConfirmed, setConsentConfirmed] = useState(false);

  // Stable anonymous session id for the operator's submission run
  const [sessionId] = useState(() =>
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`
  );

  const value = {
    isOperator: true,
    consentRef,
    setConsentRef,
    consentConfirmed,
    setConsentConfirmed,
    sessionId,
  };

  return <OperatorContext.Provider value={value}>{children}</OperatorContext.Provider>;
};

export const useOperator = () => {
  // Returns a safe default for components rendered outside operator mode
  return (
    useContext(OperatorContext) || {
      isOperator: false,
      consentRef: '',
      setConsentRef: () => {},
      consentConfirmed: false,
      setConsentConfirmed: () => {},
      sessionId: '',
    }
  );
};
